/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramProductsModeratorControllerStopModerationMutationResponse,
  TelegramProductsModeratorControllerStopModeration401,
} from '../../types/TelegramProductsModeratorControllerStopModeration.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramProductsModeratorStopModeration } from '../../methods/telegramProductsModeratorStopModeration.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramProductsModeratorStopModerationMutationKey = () =>
  [{ url: '/api/moderator/telegram/products/stop' }] as const;

export type TelegramProductsModeratorStopModerationMutationKey = ReturnType<
  typeof telegramProductsModeratorStopModerationMutationKey
>;

/**
 * {@link /api/moderator/telegram/products/stop}
 */
export function useTelegramProductsModeratorStopModeration<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramProductsModeratorControllerStopModerationMutationResponse,
      ResponseErrorConfig<TelegramProductsModeratorControllerStopModeration401>,
      void,
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramProductsModeratorStopModerationMutationKey();

  return useMutation<
    TelegramProductsModeratorControllerStopModerationMutationResponse,
    ResponseErrorConfig<TelegramProductsModeratorControllerStopModeration401>,
    void,
    TContext
  >(
    {
      mutationFn: async () => {
        return telegramProductsModeratorStopModeration(config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
